import React from 'react'
import { Dialog } from '@mui/material'

import { LxLoadingSpinner } from '@components/loader/loadingSpinner'
import styles from './AccountsList.module.scss'
import sharedStyles from '@src/pages/MultiPage.module.scss'
import { isNilOrEmpty } from '@src/utils/isNilOrEmpty'

import { AccountsListF } from './AccountsList'
import { useModal } from '@src/logic/contexts/Modal/ModalContext'
import { AccountEdit } from './Edit/AccountEdit'
import LxCancelButton from '@src/components/cancelButton/LxCancelButton'
import LxSaveButton from '@src/components/saveButton/LxSaveButton'
import { UserF } from '@src/logic/contexts/Users/UsersFrontend.type'

interface AccountInfoProps {
  open: boolean
  onClose: () => void
  account: AccountsListF | null
  canEditAccount: boolean
  canEditGlobalAccount: boolean
  currentUser: UserF
  onUpdated?: () => void
}

const AccountInfo: React.FC<AccountInfoProps> = ({ open, onClose, account, canEditAccount, canEditGlobalAccount, currentUser, onUpdated }) => {
  const { showModal } = useModal()
  const editable =  canEditGlobalAccount || (canEditAccount && account?.accountId === currentUser.accountId)

  const formatAddress = (address: any) => {
    const addressLines = [address.address_line_1, address.address_line_2, address.address_line_3].filter(Boolean)

    const locationParts = [address.city, address.state, address.postcode].filter(Boolean)

    const parts = []

    if (addressLines.length > 0) {
      parts.push(addressLines.join(', '))
    }

    if (locationParts.length > 0) {
      parts.push(locationParts.join(', '))
    }

    if (address.country) {
      parts.push(address.country)
    }

    return parts.join('\n')
  }

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth role='dialog'>
        <div className={styles.dialogHeader}>
          <h3>{account?.accountName ? `Account: ${account.accountName}` : 'Account Information'}</h3>
        </div>

        <div className={styles.dialogContent}>
          {!account ? (
            <LxLoadingSpinner className={sharedStyles.loader} />
          ) : isNilOrEmpty(account) ? (
            <div className={sharedStyles.notFound}>No account information found.</div>
          ) : (
            <>
              <div className={styles.infoRow}>
                <strong>Customer Id:</strong>
                <span>{account?.customerId}</span>
              </div>
              <div className={styles.infoRow}>
                <strong>Country:</strong>
                <span>{account?.accountCountry}</span>
              </div>

              {account?.address && (
                <div className={styles.infoRow}>
                  <strong>Address:</strong>
                  <div style={{ whiteSpace: 'pre-line' }}>{formatAddress(account.address)}</div>
                </div>
              )}
            </>
          )}
        </div>

        <div className={styles.dialogActions}>
          <LxCancelButton onCancel={onClose} classNames='lxActionButton, lxActionButtonDefaultSize' label='Close' />
          {editable && (
            <LxSaveButton
              label='Edit Account Info'
              classNames='lxActionButton,lxActionButtonFilled,lxActionButtonDefaultSize'
              onSubmit={() =>
                showModal(
                  <AccountEdit
                    account={account}
                    onUpdated={() => {
                      onUpdated?.()
                      onClose()
                    }}
                  />
                )
              }
            />
          )}
        </div>
      </Dialog>
    </>
  )
}

export default AccountInfo
